import { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { pick } from 'lodash';
import PropTypes from 'prop-types';
import {
  registerModal,
  requestToHide,
  requestToShow,
} from 'common/js/modal_controller';

const ModalInner = ({ children, id, show, onHide, ...args }) => {
  const [display, setDisplay] = useState(false);

  const onVisibleChange = useCallback(
    (value) => {
      setDisplay(value);
    },
    [setDisplay]
  );

  useEffect(() => {
    const revokable = registerModal({ id, onVisibleChange });

    return () => {
      requestToHide({ id });
      revokable?.revoke();
    };
  }, [id, onVisibleChange]);

  useEffect(() => {
    if (show) {
      requestToShow({ id });
    } else {
      requestToHide({ id });
    }
  }, [show, id]);

  const onHideCb = useCallback(
    (e) => {
      requestToHide({ id });
      onHide?.(e);
    },
    [onHide, id]
  );

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Modal id={id} show={display} onHide={onHideCb} {...args}>
      {children}
    </Modal>
  );
};

const ModalWrapper = ({ id, ...args }) =>
  // eslint-disable-next-line react/jsx-props-no-spreading
  id ? <ModalInner id={id} {...args} /> : <Modal {...args} />;

Object.assign(
  ModalWrapper,
  pick(Modal, ['Body', 'Header', 'Title', 'Footer', 'Dialog'])
);

const propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  show: PropTypes.bool,
  onHide: PropTypes.func,
};

ModalWrapper.propTypes = propTypes;
ModalInner.propTypes = propTypes;

export default ModalWrapper;
